export default "__VITE_ASSET__Dl9UsbGj__"